/** 홈 첫 장면(`story` 미디어 폴더) 파일 — 첫 장면과 같은 현장 사진을 쓰는 화면(오류 화면)이 함께 쓴다 */
export const STORY_FRAME_COUNT = 36;
export const STORY_TOP_IMAGE = "top-2800.webp";
/** 장면 데이터가 오기 전 보이는 흑백에 가까운 현장 정사영상 */
export const STORY_POSTER_IMAGE = "top-1836.webp";
